import { AccessorsMutatorsDecorator } from '../../helpers/model';
import { PropertyAccommodationType } from './property-accommodation-type.model';

export class DashboardAccommodationType extends PropertyAccommodationType {

    getRoomNumbers(value) {
        
        return value || [];
    }
}

AccessorsMutatorsDecorator(
    'id',
    ...PropertyAccommodationType.translatableAttributesWithLanguageAliases,
    'name',
    'name_ar',
    'logo',
    'images',
    'abbreviation',
    'private_or_shared',
    'number_of_units',
    'property',
    'room_numbers',
    'maximum_occupancy',
    'adults_included_in_rate',
    'children_included_in_rate',
    'number_of_shared_dorm_rooms',
    'dorm_beds_per_room',
    'shared_room_gender',
    'custom_amenities',
    'room_amenities',
    'room_numbers_length',
    'order',
    'addon_intervals',
    'free_rooms_quantity',
    'base_rates',
    'reservation_accommodations_count'
)(DashboardAccommodationType);



// WEBPACK FOOTER //
// ./src/pms-api/models/dashboard-accommodation.model.js